import { NgModule } from '@angular/core';
import { ChipListExpandDirective } from './directives/chip-list-expand.directive';

@NgModule({
  imports: [ChipListExpandDirective],
  exports: [ChipListExpandDirective],
})
export class ChipListModule {}
